module.exports = __webpack_public_path__ + "static/media/more_vertical_white.976ef87a.svg";